<!-- eslint-disable -->
<template lang="pug">
    cs-modal(@close="closeCreateMessageModal", :is-blur="true")
        .create-message__header(v-if="!this.successfullyAdded")
            div(slot='header')
                | {{ $i18n.t('conversations.conversations_createMessage_messageCreating') }}
            .create-message
                label.create-message__label
                    | {{ $i18n.t('conversations.conversations_createMessage_recipients') }}
                cs-multiselect(
                    :options='authUser.isSuperadmin || authUser.isManagerOrSupport ? usersWithCategories : users',
                    :show-labels='false',
                    :hide-selected='true',
                    :searchable='true',
                    label='fullName',
                    track-by='id',
                    :max-height='150',
                    :loading='loadingUsers',
                    :placeholder="$i18n.t('conversations.conversations_createMessage_addRecipient')",
                    :multiple='true',
                    @open='asyncFindUser',
                    @search-change='asyncFindUser',
                    v-model='form.users',
                    v-validate="'required'",
                    data-vv-value-path='innerValue',
                    data-vv-name='receivers',
                    data-vv-as='получатели'
                )
                    span(slot='noResult')
                        | {{ $i18n.t('conversations.conversations_createMessage_notFound') }}
                label.create-message__label
                    | {{ $i18n.t('conversations.conversations_createMessage_message') }}
                textarea.create-message__textarea(v-model='form.body', v-autosize="", v-focus="")
            .create-message__buttons
                label.label-button(for='file-select')
                    svg-icon.label-button__icon(name="paperclip", height="19px", width="19px")
                    span
                        | {{ $i18n.t('conversations.conversations_conversation_attachFiles') }}
                    input#file-select(type='file', ref='fileSelect', @change='setFiles', multiple)
                cs-button(
                    color="blue"
                    :disabled="!(form.users.length && form.body.length)",
                    @click="sendMessage"
                )
                    | {{ $i18n.t('conversations.conversations_conversation_sendMessage') }}
            .create-message__attachment-files(v-if='files.length')
                .create-message__attachment(v-for='(file, index) in files')
                    | {{ file.name }}
                    a.create-message__delete-file(href='javascript://', @click='deleteFile(index)')
                        svg-icon(name="cancel", size="x-large")
        .create-message__send(v-else)
            span
                svg-icon.create-message__send_successfully-added(name="check", size="xx-large")
            span.create-message__send_text
                | {{ $i18n.t('conversations.conversations_createMessage_messageWasSend') }}
</template>

<script>
    /*eslint-disable*/
    import UserApi from '../api/user/user';

    import CsModal from '../elements/CsModal.vue'

    import {mapState} from 'vuex';

    export default {
        components: {
            CsModal,
        },
        data() {
            return {
                users: [],
                loadingUsers: false,
                files: [],
                successfullyAdded: false,
                form: {
                    users: [],
                    name: '',
                    body: '',
                    gradeId: null,
                    userId: null
                },
                categories: [
                    {
                        id: -3,
                        fullName: this.$i18n.t('conversations.conversations_conversationUsers_allAdmins'),
                        type: 'admin',
                        all: true
                    },
                    {
                        id: -2,
                        fullName: this.$i18n.t('conversations.conversations_conversationUsers_allTeachers'),
                        type: 'teacher',
                        all: true
                    },
                    {
                        id: -1,
                        fullName: this.$i18n.t('conversations.conversations_conversationUsers_allStudents'),
                        type: 'student',
                        all: true
                    }
                ]
            };
        },
        mounted() {
            window.addEventListener('beforeunload', this.setDataToSessionStorage, {once: true});
            if (this.gradeId) {
                this.form.body = window.sessionStorage.getItem(`messageToGrade${this.gradeId}`) || '';
                this.form.gradeId = this.gradeId;
            } else if (this.user) {
                this.form.users.push(this.user);
                this.form.body = window.sessionStorage.getItem(`messageToUser${this.user.id}`) || '';
                this.form.userId = this.user.id;
            } else {
                this.form.body = window.sessionStorage.getItem(`message`) || '';
            }
            if (this.receivers) {
                this.form.users = this.form.users.concat(this.receivers.filter(user => user.status === 'active'));
            }
            if (this.name) {
                this.form.name = this.name;
            }
        },
        beforeDestroy () {
            this.setDataToSessionStorage();
            window.removeEventListener('beforeunload', this.setDataToSessionStorage)
        },
        props: ['user', 'receivers', 'name', 'schoolId', 'gradeId'],
        methods: {
            setDataToSessionStorage () {
                if (this.user) {
                    window.sessionStorage.setItem(`messageToUser${this.user.id}`, this.form.body)
                } else if (this.gradeId) {
                    window.sessionStorage.setItem(`messageToGrade${this.gradeId}`, this.form.body)
                } else {
                    window.sessionStorage.setItem(`message`, this.form.body)
                }
            },
            asyncFindUser(query) {
                if (this.users.length || this.authUser.isSuperadmin || this.authUser.isManagerOrSupport) {
                    return;
                }
                this.loadingUsers = true;
                let form = {
                    fullName: query,
                    type: 'user',
                    status: 'active',
                    schoolId: this.schoolId && !this.gradeId ? this.schoolId : null,
                    gradeIds: this.schoolId && this.gradeId ? [this.schoolId, this.gradeId] : null,
                    all: true,
                    isForConversation: true
                };
                UserApi.list(form).then((data) => {
                    data.users && (this.users = data.users);
                    this.users.forEach((item) => {
                        item.fullName = `${item.firstName} ${item.lastName}`
                    });
                    this.loadingUsers = false;
                }).catch(err => {
                    this.loadingUsers = false;
                });
            },
            setFiles(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    return;
                }
                for (let file of files) {
                    if (this.files.length < 10) {
                        if (!(this.isInFiles(file))) {
                            this.files.push(file);
                        }
                    }
                }
                e.target.value = '';
            },
            isInFiles(file) {
                for (let localFile of this.files) {
                    if (localFile.name === file.name && file.size === localFile.size) {
                        return true;
                    }
                }
                return false;
            },
            deleteFile(index) {
                this.files.splice(index, 1);
            },
            sendMessage() {
                this.successfullyAdded = !this.successfullyAdded;
                setTimeout(() => {
                    this.$emit('send', this.form, this.files)
                    this.$emit('close')
                }, 5000);

            },
            closeCreateMessageModal() {
                this.successfullyAdded
                        ? this.$emit('send', this.form, this.files) && this.$emit('close')
                        : this.$emit('close');
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user
            }),
            selectedCategories () {
                return this.form.users.filter(user => user.id < 0).map(category => category.type);
            },
            usersWithCategories () {
                return [
                    ...this.categories,
                    ...this.users.filter(user => !this.selectedCategories.includes(user.type))
                ];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .create-message__header {
        font-size: 22px;
        font-weight: 500;
        margin-top: 15px;
    }

    .create-message__label {
        font-size: 16px;
        line-height: 19px;
        text-align: left;
        display: flex;
        margin: 20px 0 10px 0;
    }


    .create-message__textarea {

        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border-radius: $border-radius-5;
        border: 1px solid $hsl-color-gray-74;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        //@include inset-squish-space($space-small);

        padding: 12px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }

        align-items: center;
        height: 2.25em;
        justify-content: flex-start;
        position: relative;
        vertical-align: top;
        background-color: #fff;
        box-shadow: inset 0 1px 2px hsla(0,0%,4%,.1);
        max-width: 100%;

        display: block;
        min-width: 100%;

        word-wrap: break-word;
        resize: none;
        max-height: 200px;
        min-height: 180px;

        overflow: hidden;
        overflow-wrap: break-word;
    }

    .create-message__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 30px;
        @include media($md) {
            justify-content: space-between;
            flex-direction: row;
        }
    }

    .create-message__attachment-files {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        margin-top: 20px;
    }

    .create-message__attachment {
        display: flex;
        align-items: center;
        margin-right: 20px;
    }

    .create-message__delete-file {
        color: $hsl-color-gray-74;
        &:hover {
            color: $hsl-color-red-62;
        }
    }

    .label-button {
        box-sizing: border-box;

        padding: 15px 30px;

        transition: 0.3s;

        font-weight: normal;
        font-size: 16px;
        line-height: 19px;

        border-radius: $border-radius-40;

        cursor: pointer;
        outline: none;

        display: flex;
        vertical-align: middle;
        text-align: center;
        justify-content: center;
        align-items: center;

        color: $hsl-color-blue-56;
        background-color: transparent;
        border: 1px solid $hsl-color-blue-56;


        margin-bottom: 10px;
        @include media($md) {
            margin-bottom: 0;
        }
    }

    .label-button:hover {
        color: $x-color-white;
        background-color: $hsl-color-blue-48;
    }

    .label-button__icon {
        margin-right: 14px;
    }

    #file-select {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
    }

    .create-message__send {
        display: flex;
        flex-direction: column;
    }

    .create-message__send_successfully-added {
        border-radius: 50%;
        color: $hsl-color-green-58;
        border: 4px solid $hsl-color-green-58;
        padding: 8px;
        margin-bottom: 20px;
    }

    .create-message__send_text {
        font-size: 22px;
        font-weight: 500;
    }

</style>
